module.exports = __webpack_public_path__ + "img/tss-1.37cb0b09.jpg";